export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;
export const API_IMAGES_BASE_URL = process.env.VUE_APP_API_IMAGES_BASE_URL;
